import React from "react";
import { Card } from "antd";

export const ItemList = ({ onClick, children, rightComponent, leftComponent, hoverable = true }) => {
  return (
    <Card bodyStyle={{ padding: 15 }} className={hoverable && "item-hoverable"} onClick={onClick}>
      <div className="content-item-list">
        {leftComponent}
        <div className="item-list-description-content">{children}</div>
        {rightComponent}
      </div>
    </Card>
  );
};
